
import { Order } from "@/types/order";
import { Progress } from "@/components/ui/progress";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Info, PackageCheck, Cog, Truck, Home, PartyPopper } from "lucide-react";
import React from "react";

interface OrderTrackingCardProps {
  order: Order;
}

const steps = [
  { title: 'Confirmed', icon: PackageCheck },
  { title: 'Processing', icon: Cog },
  { title: 'On its way', icon: Truck },
  { title: 'Delivered', icon: Home },
  { title: 'Enjoy!', icon: PartyPopper },
];

const statusToStep: Record<string, number> = {
  confirmed: 0,
  processing: 1,
  shipped: 2,
  in_transit: 2,
  delivered: 3,
  completed: 4
};


export function OrderTrackingCard({ order }: OrderTrackingCardProps) {
  const currentStepIndex = statusToStep[order.status.status] ?? 0;
  const progress = ((currentStepIndex + 1) / steps.length) * 100;
  
  // Mock arrival time
  const arrivalTime = new Date();
  arrivalTime.setHours(22, 0, 0); 
  const latestArrivalTime = new Date(arrivalTime.getTime() + 35 * 60000);


  return (
    <Card className="w-full rounded-2xl">
      <CardHeader>
        <CardTitle className="text-lg">Shopping in progress...</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <Progress value={progress} className="h-2" />
        <div className="flex justify-between items-center bodysmall">
          <div>
            <p className="font-bold">Arriving at {arrivalTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit'})}</p>
            <div className="flex items-center gap-1 text-muted-foreground">
              <p>Latest arrival by {latestArrivalTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit'})}</p>
              <Info className="h-4 w-4" />
            </div>
          </div>
        </div>

        <div className="flex justify-between items-center">
          {steps.map((step, index) => {
            const Icon = step.icon;
            const isCompleted = index <= currentStepIndex;
            return (
              <React.Fragment key={index}>
                <div className="flex flex-col items-center gap-2">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isCompleted ? 'bg-[var(--famasi-green-100)] text-[var(--famasi-green-600)]' : 'bg-[var(--dispensary-gray-100)] text-[var(--dispensary-gray-400)]'}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <p className={`captionmedium text-center ${isCompleted ? 'font-semibold text-foreground' : 'text-muted-foreground'}`}>{step.title}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className={`flex-1 h-1 mx-2 ${isCompleted ? 'bg-[var(--famasi-green-500)]' : 'bg-[var(--dispensary-gray-200)]'}`} />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </CardContent>
    </Card>
  )
}
